"use client";

import styled from "styled-components";
import { TableHead } from "../ui/table";

export const HeaderTable = styled(TableHead)`
  white-space: pre-line;
  word-break: break-word;
  line-height: 1.2;
  height: auto;
  button {
    padding: 0;
    cursor: pointer;

    &:hover {
      background: transparent;
    }
  }
`;

export const FooterTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
`;

export const FirstBoxFooter = styled.div`
  flex: 1;
  font-size: 0.875rem;
  color: var(--muted-foreground);

  @media (max-width: 768px) {
    text-align: center;
    font-size: 0.75rem;
  }
`;

export const PaginationBox = styled.div`
  display: flex;
  gap: 0.5rem;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;

    button {
      flex: 1;
      min-width: 100px;
    }
  }
`;
